import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { environment } from "../../environments/environments";
import socketServices from "../api/socket";
import "./ChatConsult.css";

const ChatConsult = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {};
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState("");
  const [currUser, setCurrUser] = useState(null);
  const [reportModalVisible, setReportModalVisible] = useState(false);
  const [reportMessageId, setReportMessageId] = useState(null);
  const [reportText, setReportText] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
  const [token, setToken] = useState("");
  const [emptyMessageModalVisible, setEmptyMessageModalVisible] =
    useState(false);
  const flatListRef = useRef(null);
  const SOCKET_SERVER_URL = environment.chatBaseUrl;

  // Fetch current user once
  useEffect(() => {
    const userData = localStorage.getItem("currentUser");
    if (userData) {
      setCurrUser(JSON.parse(userData));
    }
    getStoredToken();
  }, []);
  const getStoredToken = () => {
    try {
      const storedToken = localStorage.getItem("jwtToken");
      if (storedToken) {
        console.log("Retrieved Token:", storedToken);
        setToken(storedToken);
      }
    } catch (error) {
      console.error("Error retrieving token:", error);
    }
  };

  // Initialize socket and load messages
  useEffect(() => {
    if (!currUser || !item?.id) return;

    socketServices.initializeSocket();

    socketServices.emit("userConnected", currUser._id || currUser.id);

    const messageListener = (data) => {
      setMessages((prevMessages) => [...prevMessages, data]);
    };

    socketServices.on("receiveMessage", messageListener);

    // Fetch chat history
    const loadChats = async () => {
      try {
        const res = await fetch(
          `${SOCKET_SERVER_URL}/chats/${currUser._id || currUser.id}/${
            item?.id
          }`
        );
        const chats = await res.json();
        setMessages(chats);
      } catch (error) {
        console.error("Error loading chats:", error);
      }
    };
    loadChats();

    return () => {
      socketServices.emit("userDisconnected", currUser._id || currUser.id);
    };
  }, [currUser, item?.id]);

  const scrollToBottom = () => {
    if (flatListRef.current) {
      flatListRef.current.scrollTop = flatListRef.current.scrollHeight;
    }
  };

  const handleSubmitReport = async () => {
    const value = {
      user_id: currUser._id || currUser.id,
      reported_user_id: item?.id,
      message_id: reportMessageId,
      description: reportText,
      reason: selectedReason,
      reported_type: "counsellor",
      reporter_type: "user",
    };

    try {
      const res = await fetch(`${SOCKET_SERVER_URL}/report`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(value),
      });
      const response = await res.json();
      if (response.success) {
        alert("Reported Successfully");
        setReportModalVisible(false);
        setSelectedReason("");
      }
    } catch (error) {
      console.error("Report error:", error);
    }
  };

  const sendMessage = async () => {
    if (!inputText.trim()) return;

    const messageData = {
      from: currUser._id || currUser.id,
      to: item?.id,
      msg: inputText.trim(),
      connected_user_status: "approved",
      chatmode: "user",
      sender_id: currUser._id || currUser.id,
      jwtsecret: token,
    };
    console.log("messageData", messageData);
    try {
      const response = await fetch(`${SOCKET_SERVER_URL}/send-message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(messageData),
      });
      console.log("response222222222", response);
      const responseData = await response.json();

      if (responseData) {
        setInputText("");
        socketServices.emit("sendMessage", messageData);
        scrollToBottom();
      } else {
        console.log("Error sending message");
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const renderMessage = (message) => {
    const userId = currUser?._id || currUser?.id;
    const isSentByCurrentUser = message.sender_id === userId;

    return (
      <div
        key={message._id || message.timestamp}
        className={`message ${isSentByCurrentUser ? "sent" : "received"}`}
      >
        <div className="message-text">{message.msg}</div>
        <div className="message-time">
          {new Date(message.timestamp).toLocaleTimeString()}
        </div>
      </div>
    );
  };

  if (!currUser || !item) return <div>Loading chat...</div>;

  return (
    <div className="chat-consult">
      <div className="header">
        <button onClick={() => navigate(-1)}>Back</button>
        <div className="profile">
          <img
            src={`${environment.url}/uploads/counsellors/${item?.image}`}
            alt="Profile"
          />
          <div>
            <h3>{item?.name}</h3>
          </div>
        </div>
      </div>

      <div ref={flatListRef} className="messages">
        {messages
          .filter((message) => message.msg?.trim())
          .map((message) => renderMessage(message))}
      </div>

      <div className="input-container">
        <textarea
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder="Type a message..."
        />
        <button onClick={sendMessage}>Send</button>
      </div>

      {reportModalVisible && (
        <div className="modal">
          <div className="modal-content">
            <h4>Report Message</h4>
            <button onClick={() => setReportModalVisible(false)}>Close</button>
            <textarea
              value={reportText}
              onChange={(e) => setReportText(e.target.value)}
              placeholder="Enter reason for report..."
            />
            {["Abuse", "Threat", "Violence", "Nudity", "Other"].map(
              (reason) => (
                <div key={reason} onClick={() => setSelectedReason(reason)}>
                  <span>{reason}</span>
                </div>
              )
            )}
            <button onClick={handleSubmitReport}>Submit</button>
          </div>
        </div>
      )}

      {emptyMessageModalVisible && (
        <div className="modal">
          <div className="modal-content">
            <h4>No Messages</h4>
            <button onClick={() => setEmptyMessageModalVisible(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatConsult;
